/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato di consumo di un voucher nel suo ciclo di vita
 */
export enum VoucherStatus {

    ASSEGNATO = 'ASSEGNATO',

    DA_CONSUMARE = 'DA_CONSUMARE',

    PARZIALMENTE_CONSUMATO = 'PARZIALMENTE_CONSUMATO',

    CONSUMATO = 'CONSUMATO',

    ANNULLATO = 'ANNULLATO'
}

